export class RunsConfig {
    slotOneFieldName: string;
    slotOneLabel: string;
    slotTwoFieldName: string;
    slotTwoLabel: string;

    timeValue: boolean;
    scoreValue: boolean;
    decimalPlaces: number;

    constructor() {
        this.slotOneFieldName = 'contestantOne.firstName+contestantOne.lastName';
        this.slotOneLabel = 'Rider';
        this.slotTwoFieldName = 'horseOne.name';
        this.slotTwoLabel = 'Horse';
        this.timeValue = true;
        this.scoreValue = false;
        this.decimalPlaces = 3;
    }
}


// WEBPACK FOOTER //
// ./src/model/runsConfig.ts